import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../components/Checkbox/Checkbox";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import TextAreaInput from "../../../components/TextAreaInput/TextAreaInput";
import { useAuth } from "../../../contexts/auth";
import { useListManager } from "../../../contexts/list.manager";
import ShiftService from "../../../services/ShiftService";
import "./FormTurnos.css";
import { useUserStore } from "../../../contexts/userStore";
import { LevelSelector } from "../../../components/LevelSelector/LevelSelector";
import { parseTimeToTimezone } from "../../../utils/date";
import { LuClock } from "react-icons/lu";

function FormTurnos(props) {
	const { user } = useAuth();
	const { selectedCondominio } = useUserStore()
	const [name, setName] = useState(props.turno?.name || "");
	const [description, setDescription] = useState(props.turno?.descricao || "");
	const [levels, setLevels] = useState([]);
	const [responsible, setResponsible] = useState(
		props.turno?.responsavel || ""
	);
	const [phoneResponsible, setPhoneResponsible] = useState(
		props.turno?.responsible_phone || ""
	);
	const [startTime, setStartTime] = useState(props.turno?.horario_inicio || "");
	const [endTime, setEndTime] = useState(props.turno?.horario_fim || "");

	const [sundayEnabled, setSundayEnabled] = useState(
		props.turno?.dias_semana
			? props.turno.dias_semana.includes("Domingo")
			: false
	);
	const [mondayEnabled, setMondayEnabled] = useState(
		props.turno?.dias_semana
			? props.turno.dias_semana.includes("Segunda")
			: false
	);
	const [tuesdayEnabled, setTuesdayEnabled] = useState(
		props.turno?.dias_semana ? props.turno.dias_semana.includes("Terça") : false
	);
	const [wednesdayEnabled, setWednesdayEnabled] = useState(
		props.turno?.dias_semana
			? props.turno.dias_semana.includes("Quarta")
			: false
	);
	const [thursdayEnabled, setThursdayEnabled] = useState(
		props.turno?.dias_semana
			? props.turno.dias_semana.includes("Quinta")
			: false
	);
	const [fridayEnabled, setFridayEnabled] = useState(
		props.turno?.dias_semana ? props.turno.dias_semana.includes("Sexta") : false
	);
	const [saturdayEnabled, setSaturdayEnabled] = useState(
		props.turno?.dias_semana
			? props.turno.dias_semana.includes("Sábado")
			: false
	);

	const [showLoader, setShowLoader] = useState(false);
	const { closeForm } = useListManager();
	const navigate = useNavigate();

	useEffect(() => {
		setName(props.turno?.name || "");
		setDescription(props.turno?.descricao || "");
		setStartTime(props.turno?.horario_inicio || "");
		setEndTime(props.turno?.horario_fim || "");
		setLevels(props.turno?.levels?.map(level => ({ unitId: `${level.unitId}`, hierarchy: level.childrenAuthorized })) || []);
		if (props.turno?.dias_semana) { // && Array.isArray(props.turno.dias_semana)) {
			setSundayEnabled(props.turno.dias_semana.includes("Domingo"));
			setMondayEnabled(props.turno.dias_semana.includes("Segunda"));
			setTuesdayEnabled(props.turno.dias_semana.includes("Terça"));
			setWednesdayEnabled(props.turno.dias_semana.includes("Quarta"));
			setThursdayEnabled(props.turno.dias_semana.includes("Quinta"));
			setFridayEnabled(props.turno.dias_semana.includes("Sexta"));
			setSaturdayEnabled(props.turno.dias_semana.includes("Sábado"));
		}
	}, [props.turno]);

	const buildPayload = () => {
		const days = [];
		if (sundayEnabled) days.push("Domingo");
		if (mondayEnabled) days.push("Segunda");
		if (tuesdayEnabled) days.push("Terça");
		if (wednesdayEnabled) days.push("Quarta");
		if (thursdayEnabled) days.push("Quinta");
		if (fridayEnabled) days.push("Sexta");
		if (saturdayEnabled) days.push("Sábado");

		return {
			name,
			organizationId: user.userData.selectedOrganizationId,
			unitId: `${selectedCondominio}`,
			description,
			startTime: parseTimeToTimezone(startTime),
			endTime: parseTimeToTimezone(endTime),
			daysOfWeek: days,
			levels: levels.map(level => ({ unitId: level.unitId, childrenAuthorized: level.hierarchy })),
		};
	};

	async function handleSubmit(event) {
		event.preventDefault();
		setShowLoader(true);
		const payload = buildPayload();
		let response = {};

		if (props.type === "edicao") {
			response = await ShiftService.updateShift(props.turno.id, payload);
		} else if (props.type === "cadastro") {
			response = await ShiftService.createShift(payload);
		}

		setShowLoader(false);
		if (!response?.data?.id) return;
		navigate("../consulta-turnos", {
			state: { refresh: true }
		});
	}

	async function handleDelete() {
		setShowLoader(true);
		if (!props.turno) return;
		await ShiftService.deleteShift(props.turno.id);
		navigate("../consulta-turnos", {
			state: { deletedId: props.turno.id },
		});
		setShowLoader(false);
		closeForm();
	}

	const handleClickEditButton = () => {
		if (!props.turno) return;
		navigate(`/turnos/${props.turno.externalId}`, { state: props.turno });
	};

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				icon={<LuClock size={20} />}
				tituloConsulta={props.turno?.name || null}
				tituloCadastro="Cadastro de Turno"
				backRoute={"/consulta-turnos"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleDelete={handleDelete}
					handleClickEdit={handleClickEditButton}
					navigateCancelUrl="../consulta-turnos"
				>
					<div className="turno-form-grid">
						<div className="container-info-turno">
							<Input
								name="name"
								id="name"
								labelText="Nome do Turno *"
								value={name}
								onChange={({ target }) => setName(target.value)}
								disabled={props.type === "consulta"}
								required={true}
							/>

							{/* TODO: Criar componente seletor de pessoa */}
							{/* <Input
								name="responsible"
								id="responsible"
								labelText="Responsável"
								value={responsible}
								onChange={({ target }) => setResponsible(target.value)}
								disabled={props.type === "consulta"}
							/>
							<Input
								name="responsible_phone"
								id="responsible_phone"
								labelText="Telefone do Responsável"
								value={phoneResponsible}
								onChange={({ target }) => setPhoneResponsible(target.value)}
								disabled={props.type === "consulta"}
							/> */}

							<TextAreaInput
								name="description"
								id="description"
								labelText="Descrição"
								value={description}
								onChange={({ target }) => setDescription(target.value)}
								disabled={props.type === "consulta"}
							/>
							{props.type === "consulta" && (
								<>
									<Input
										name="horario_inicio"
										id="horario_inicio"
										labelText="Horário de Início"
										value={startTime}
										disabled={true}
									/>
									<Input
										name="horario_fim"
										id="horario_fim"
										labelText="Horário de Fim"
										value={endTime}
										disabled={true}
									/>
								</>
							)}
							{props.type !== "consulta" && (
								<LevelSelector
									onChange={(levels) => {
										setLevels(levels.map(level => ({
											unitId: level.unitId,
											hierarchy: level.childrenAuthorized
										})));
									}}
									levels={levels.map(level => ({
										unitId: level.unitId,
										childrenAuthorized: level.hierarchy
									}))}
									showRoot={true}
									type={props.type}
									title={"Níveis"}
									description={"Selecione os níveis que o turno pertence"} />
							)}
						</div>
						{props.type !== "consulta" && (
							<div className="date-time-box">
								<div className="date-time-container-turnos">
									<h3 className="box-title">Horário e Datas</h3>
									<div className="date-time-grid">
										<Input
											name="start_hour"
											id="start_hour"
											type="time"
											min="00:00"
											max="23:59"
											labelText="Hora Início"
											value={startTime}
											onChange={({ target }) => setStartTime(target.value)}
											disabled={props.type === "consulta"}
											tooltipText="Hora de início do turno"
											tooltipVisible={true}
										/>
										<Input
											name="end_hour"
											id="end_hour"
											type="time"
											min="00:00"
											max="23:59"
											labelText="Hora Fim"
											value={endTime}
											onChange={({ target }) => setEndTime(target.value)}
											disabled={props.type === "consulta"}
											tooltipText="Hora de fim do turno"
											tooltipVisible={true}
										/>
									</div>
								</div>
								<div className="group-of-inputs-container-turnos">
									<p className="group-of-inputs-title">Dias da semana ativos</p>
									<div className="checkbox-container-turnos">
										<Checkbox
											labelText="Domingo"
											checked={sundayEnabled}
											onChange={({ target }) =>
												setSundayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
										<Checkbox
											labelText="Segunda"
											checked={mondayEnabled}
											onChange={({ target }) =>
												setMondayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
										<Checkbox
											labelText="Terça"
											checked={tuesdayEnabled}
											onChange={({ target }) =>
												setTuesdayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
										<Checkbox
											labelText="Quarta"
											checked={wednesdayEnabled}
											onChange={({ target }) =>
												setWednesdayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
										<Checkbox
											labelText="Quinta"
											checked={thursdayEnabled}
											onChange={({ target }) =>
												setThursdayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
										<Checkbox
											labelText="Sexta"
											checked={fridayEnabled}
											onChange={({ target }) =>
												setFridayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
										<Checkbox
											labelText="Sábado"
											checked={saturdayEnabled}
											onChange={({ target }) =>
												setSaturdayEnabled(target.checked)
											}
											inputWidth="200px"
											minWidthLabel="120px"
											disabled={props.type === "consulta"}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormTurnos;
